// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:769px){.filter-popup__button-container{justify-content:flex-end}.filter-popup__filter-items{overflow-x:auto}}", ""]);
// Exports
module.exports = exports;
